import React from 'react';
import cx from 'classnames';
import { compact, isNull } from 'lodash';
import moment from 'moment-timezone';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import CardLayout from '@magoosh/layouts/card';
import { paths } from 'config/path_helpers';
import { MockTest } from 'types/mock_test';

import ContextualLink from '@test_prep/app/components/contextual_link';

import { SectionOption } from '../../types';

interface Props {
  condensed: boolean;
  mockTest: MockTest;
  selectedSectionOption: SectionOption;
}

export default (props: Props) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

  const scoresToDisplay = () => {
    if (props.selectedSectionOption.sectionTest) {
      return props.mockTest.sectionScores.filter((sectionScore) => (
        sectionScore.name === props.selectedSectionOption.name
      ));
    } else if (props.condensed) {
      return compact([props.mockTest.score]);
    } else {
      return compact([...props.mockTest.sectionScores, props.mockTest.score]);
    }
  };

  // CSS classes are provided in _score_badge.scss
  return (
    <CardLayout.Card className="d-flex flex-column gap-s">
      <div className="d-flex gap-s">
        <div className="d-flex flex-column gap-xs">
          <div><strong>{props.mockTest.name}</strong></div>
          <div className="tiny text-gray-light">
            {moment(props.mockTest.createdAt * 1000).tz(timeZone).format('MMMM D, YYYY')}
          </div>
        </div>

        <div className="d-flex flex-1 justify-content-end">
          <ContextualLink
            className="small text-gray-light text-hover-no-decoration text-no-decoration"
            href={paths.practiceTest(props.mockTest.id)}
          >
            View Details
          </ContextualLink>
        </div>
      </div>

      <ul className="mock-test-score-group u-margin-A-n vertical">
        {
          scoresToDisplay().map((score) => (
            <li key={score.name}>
              <div className={cx(
                'mock-test-score',
                {
                  disabled: isNull(score.value),
                  primary: score === props.mockTest.score
                }
              )}>
                {
                  isNull(score.value) && score.explanation ? (
                    <OverlayTrigger
                      overlay={
                        <Tooltip id={`score-explanation-tooltip-${score.name}`}>
                          {score.explanation}
                        </Tooltip>
                      }
                      placement="top"
                    >
                      <span className="text-underdash">NS</span>
                    </OverlayTrigger>
                  ) : (
                    <span>
                      {isNull(score.value) ? 'NS' : score.value}
                    </span>
                  )
                }
              </div>
              <span className="mock-test-score-text">{score.name}</span>
            </li>
          ))
        }
      </ul>
    </CardLayout.Card>
  );
};
